import React, { useState, useEffect } from 'react';

// Компоненты
import HeaderStart from './Header&CodeInput/HeaderStart.jsx';
import BoostRobot from './BoostRobot.png';
import Chat from './Chat.jsx';

export default function Main() {
  const [isFooterVisible, setIsFooterVisible] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0); // Имитация "скролла"
  const [isAtBottom, setIsAtBottom] = useState(false); // Флаг, достигнут ли "низ страницы"
  const [startY, setStartY] = useState(null); // Начальная позиция касания

  const maxScroll = 100; // Максимальное значение "скролла"

  // Обработчик для wheel (ПК)
  const handleWheel = (e) => {
    const deltaY = e.deltaY;
    updateScrollPosition(deltaY);
  };

  // Обработчики для touch (мобильные устройства)
  const handleTouchStart = (e) => {
    setStartY(e.touches[0].clientY); // Запоминаем начальную точку касания
  };

  const handleTouchMove = (e) => {
    if (startY === null) return;

    const currentY = e.touches[0].clientY;
    const deltaY = startY - currentY; // Разница между текущей и начальной позицией
    updateScrollPosition(deltaY);
  };

  // Обновление состояния скролла
  const updateScrollPosition = (deltaY) => {
    let newScrollPosition = scrollPosition + deltaY;

    // Ограничиваем значения скролла
    if (newScrollPosition < 0) {
      newScrollPosition = 0;
    } else if (newScrollPosition > maxScroll) {
      newScrollPosition = maxScroll;
    }

    // Устанавливаем флаг достижения "дна"
    setIsAtBottom(newScrollPosition === maxScroll);

    // Показать подвал при попытке прокрутить дальше конца
    if (newScrollPosition === maxScroll && deltaY > 0) {
      setIsFooterVisible(true);
    }

    // Скрыть подвал при движении вверх
    if (deltaY < 0) {
      setIsFooterVisible(false);
    }

    setScrollPosition(newScrollPosition);
  };

  useEffect(() => {
    // Добавляем обработчики для ПК и мобильных устройств
    window.addEventListener('wheel', handleWheel);
    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('touchmove', handleTouchMove);

    return () => {
      // Убираем обработчики
      window.removeEventListener('wheel', handleWheel);
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchmove', handleTouchMove);
    };
  }, [scrollPosition, startY]);

  return (
    <>
      <HeaderStart />
      <div className="home">
        <img className="home__img" src={BoostRobot} alt="" />
        <Chat />
      </div>
      <footer className={`footer ${isFooterVisible ? 'visible' : ''}`}>
        <div className="container">
          <ul>
            <li>ИНН 7203583939</li>
            <li>КПП 720301001</li>
            <li>ОГРН 1247200019923</li>
          </ul>
        </div>
      </footer>
    </>
  );
}
